<script>
/**
 * 该组件为实现table可选列。
 * 具体操作见下方注释。
 * 全部集成原a-table功能，使用方式与原a-table完全相同，扩展增加了可选列功能
 * 该组件已注册至全局，使用方式只需将a-table变为zyx-table即可，等等一系列原写法不变，即可增加该功能.
 * 采用rander函数模式写，为了实现a-table中slot可动态。
 */
import {Table,Input,Button,Col,Row,Checkbox} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
export default {
  name: 'Table',
  data () {
    return {
      modalVisible: false, // 弹窗
      columns: [], // 表格的列，根据条件来操作该字段
      selectList: [], // 已选择的列
      temporarySelectData: [], // 暂时选择的列，点击checkbox暂存到该字段，点确定同步到selectList
      checkboxList: [],// checkbox的list，也做总数据来使用
      indeterminate: true,
      checkAll: false,
    }
  },
  components:{
		ATable:Table,
    AInput:Input,
    AButton:Button,
    ACol:Col,
    ARow:Row,
    ACheckbox:Checkbox,
    ACheckboxGroup:Checkbox.Group,
  },
  created(){
    this.columns = this.deepClone(this.$attrs.columns)
    this.checkboxList = this.deepClone(this.$attrs.columns)
    this.selectList = this.columns.map(ele => ele.dataIndex)
  },
  mounted () {
    /**
     * 挂载后，将原columns复制到本页columns，checkboxList
     *          将selectList赋值全选状态
     */
    this.columns = this.deepClone(this.$attrs.columns)
    this.checkboxList = this.deepClone(this.$attrs.columns)
    this.selectList = this.columns.map(ele => ele.dataIndex)

    this.$post(this.url+this.hostDms +'/userTable/query',{
      userId:sessionStorage.user_id,
      route:this.$route.path,
    }).then((result) => {
      if(result.response.code=='0000'){
        if(result.response.obj==''){
          this.$post(this.url+this.hostDms +'/userTable/create',{
            userId:sessionStorage.user_id,
            route:this.$route.path,
            content:JSON.stringify([this.checkboxList,this.columns]),
          }).then((result) => {
            if(result.response.code=='0000'){
            }else{
              this.$message({
                type: 'warning',
                message: result.response.desc
              })
            }
          }).catch((err) => {
              console.log(err)
          });

        }else{
          this.checkboxList = JSON.parse(result.response.obj)[0]
          this.columns = JSON.parse(result.response.obj)[1]
          this.selectList = this.columns.map(ele => ele.dataIndex)
        }
      }else{
        this.$message({
          type: 'warning',
          message: result.response.desc
        })
      }
    }).catch((err) => {
        console.log(err)
    });
  },
  methods: {
    /**
     * 打开modal，将checkbox默认值或者是选择值（暂存）重新赋值
     */
    handelOpenSelect () {
      this.temporarySelectData = this.deepClone(this.selectList)
      this.indeterminate = this.columns.length==0 ? false : this.columns.length < this.checkboxList.length 
      this.checkAll = this.columns.length==0 ? false : this.checkboxList.length === this.columns.length
      this.modalVisible = true
    },
    /**
     * 点击确定，将暂存值赋值（temporarySelectData）给已选择的列（selectList）
     * 将列（columns）根据已选择的列（selectList）筛选出来
     */
    handleOk () {
      this.selectList = this.deepClone(this.temporarySelectData)
      this.modalVisible = false
      this.columns = this.checkboxList.filter(ele => this.selectList.includes(ele.dataIndex))
      this.$post(this.url+this.hostDms +'/userTable/create',{
        userId:sessionStorage.user_id,
        route:this.$route.path,
        content:JSON.stringify([this.checkboxList,this.columns]),
      }).then((result) => {
        if(result.response.code=='0000'){
        }else{
          this.$message({
            type: 'warning',
            message: result.response.desc
          })
        }
      }).catch((err) => {
          console.log(err)
      });
    },
    handleCancel () {
      this.modalVisible = false
    },
    handelChange (e) {
      this.indeterminate = !!e.length && e.length < this.checkboxList.length;
      this.checkAll = e.length === this.checkboxList.length;
      this.temporarySelectData = this.deepClone(e)
    },
    onCheckAllChange(e) {
      
      Object.assign(this, {
        temporarySelectData: e.target.checked ? this.deepClone(this.checkboxList.map(ele => ele.dataIndex)) : [],
        indeterminate: false,
        checkAll: e.target.checked,
      });
    },
    deepClone (target) {
      let result
      if (typeof target === 'object') {
        if (Array.isArray(target)) {
          result = []
          for (const i in target) {
            result.push(this.deepClone(target[i]))
          }
        } else if (target === null) {
          result = null
        } else if (target.constructor === RegExp) {
          result = target
        } else {
          result = {}
          for (const i in target) {
            result[i] = this.deepClone(target[i])
          }
        }
      } else {
        result = target
      }
      return result
    }
  },
  render () {
    const props = { ...this.$attrs, ...this.$props, ...{ columns: this.columns } }
    const on = { ...this.$listeners }
    const slots = Object.keys(this.$slots).map(slot => {
      return (
        <template slot={slot}>{ this.$slots[slot] }</template>
      )
    })
    const table = (
      <a-table 
        columns={this.columns}  
        dataSource={this.$attrs['data-source']}  
        pagination={this.$attrs['pagination']} 
        rowSelection={this.$attrs['row-selection']} 
        scroll={this.$attrs['scroll']}
        scopedSlots={ this.$scopedSlots } 
        on={on} 
        ref="zyxTable"
        >
        {slots}
      </a-table>
    )

    const changeDiv = (
      <a-button class="select-columns" size="small" onClick={this.handelOpenSelect}> <img src="static/img/gengduo@3x.png" alt=""/></a-button>
    )

    const checkboxArr = []
    for (let i = 0; i < this.checkboxList.length; i++) {
      checkboxArr.push(<a-col span={8}><a-checkbox value={this.checkboxList[i].dataIndex}>{this.checkboxList[i].title}</a-checkbox></a-col>)
    }
    const modal = (
      <a-modal
        title="设置列"
        visible={this.modalVisible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}>
        <div>
          <a-checkbox style='margin-bottom:10px' indeterminate={this.indeterminate} checked={this.checkAll} onChange={this.onCheckAllChange}>
            全选
          </a-checkbox>
        </div>
        <a-checkbox-group value={this.temporarySelectData} onChange={this.handelChange}>
          <a-row>
            {checkboxArr}
          </a-row>
        </a-checkbox-group>
      </a-modal>
    )

    return (
      <div class="zyx-table">
        { table }
        { changeDiv }
        { modal }
      </div>
    )
  }
}
</script>
<style lang="less" scoped>
.zyx-table{
  // position: relative;
  .select-columns{
    position: absolute;
    left: 90px;
    top: 15px;
    border:0;
    box-shadow:0;
    img {
      width: 18px;
      height: 18px;
    }
  }
}

.ant-row{
  width: 100%;

  .ant-col-8{
    margin-bottom: 10px;
  }
}

.ant-checkbox-group{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/common/table.vue